import { useEffect, useState } from 'react';
import { conexao } from './conexao';
import { IItemFila, inscreverFila, listarFila } from './fila';
import { estadoSincronizacao, IEstadoSincronizacao, inscreverSincronizacao } from './sincronizacao';

// Estado do PDV offline pra tela: conexão, fila de pendentes e andamento
// da sincronização — atualizado sozinho a cada mudança.
export const useOffline = () => {
  const [online, setOnline] = useState(conexao.estaOnline());
  const [fila, setFila] = useState<IItemFila[]>([]);
  const [sincronizacao, setSincronizacao] = useState<IEstadoSincronizacao>(estadoSincronizacao());

  useEffect(() => {
    const carregarFila = () => { listarFila().then(setFila); };
    carregarFila();
    const cancelarFila = inscreverFila(carregarFila);
    const cancelarConexao = conexao.inscrever(setOnline);
    const cancelarSincronizacao = inscreverSincronizacao(setSincronizacao);
    return () => {
      cancelarFila();
      cancelarConexao();
      cancelarSincronizacao();
    };
  }, []);

  return {
    online,
    fila,
    pendentes: fila.length,
    comErro: fila.filter((item) => item.status === 'erro').length,
    sincronizacao,
  };
};
